import { render, staticRenderFns } from "./excursion-cats-header.vue?vue&type=template&id=3c0cfe58&"
import script from "./excursion-cats-header.vue?vue&type=script&lang=ts&"
export * from "./excursion-cats-header.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports